import { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import { redirectToPos } from "../../constants/posApp";

/** Legacy /ims/cashier/* routes — send users to the standalone POS app. */
export default function PosExternalRedirect({ path = "/" }) {
  useEffect(() => {
    redirectToPos(path);
  }, [path]);

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh" }}>
      <CircularProgress sx={{ color: "var(--secColor)" }} />
    </Box>
  );
}
